import { TBucketId } from 'libs/services/src/lib/capacitor/bucket-storage.types';
import { TIncompleteBundle, TIncompleteBundlesInfo } from '../bundle-qc/bundle-qc.types';
import { TPaginationInfo } from '../fabric-inspection/api.types';
import { TRESPONSE_GET_PER_PIECE_LINE_IN_TRANSACTIONS } from '../per-piece-line-in/api.types';
import { TSampleModel } from '../roaming-qc/audit-dto.types';
import {
  TBulkEvent,
  TBulkEventBackgroundMetadata,
  TBulkEventWithoutStatus,
  TDefectiveReleatedEvent,
  TEventBackgroundMetadata,
  TMasterDataListMetaData,
  TMemberAdditionType,
  TPerPieceDefectiveInfoWithLinkedVId,
  TPerPieceLineInUndoDTO,
  TPerPieceQcUntoDTO,
  TRestoreBackedUpBctx,
  TSycedEventStatus,
  TUndoDTO,
  TYET_TO_BE_SYNCED,
  TActivityLogEvent,
  TSingleCountEvent,
} from './event.types';
import { TMasterdataItemInfo } from './master-data-list.types';
import { TGenericIssueDTO } from '../../ba-app';
import { TRemoteDeploymentCheck } from './remote-deployment-db.types';
import { TMeasurement_issue } from '../aql/aql.types';
import { TProductionReasonDTO } from '../../ba-app/production-variance-logging/api.types';

type TTagPreviewFieldNumbers = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14;

type TTagPreviewFields = `field${TTagPreviewFieldNumbers}`;

export type TCommonTagMappings = {
  cp: TTagPreviewFields;
  d: string;
  info_key: string;
  tag_key: string;
}[];

type TBCTXType = 'wip' | 'order' | 'plan' | 'unknown';

type TBctxSizeKey = 'size';
export type TBctxPoSplitFromDetails = 'from_po' | 'from_order_ref';
type TBctxDatetimeKey = 'datetime';
export type TBCTXKeysWithoutSize =
  | 'buyer'
  | 'style'
  | 'po'
  | 'color'
  | 'product_type'
  | 'product_category'
  | 'order_ref'
  | 'search_id'
  | 'audit_disName'
  | 'bundle_no'
  | 'display_piece_tag';
export type TBCTXKeys = TBCTXKeysWithoutSize | TBctxSizeKey;
export type TBCTXKeysWithDateTime = TBCTXKeysWithoutSize | TBctxSizeKey | TBctxDatetimeKey;
export type TSelectedBctxAndOrderKeysAndBctxKeysMap = {
  orderKeys: TBCTXKeysWithoutSize[];
  selectedBctxInfo: TSelectedBctxInfo;
  bctxKeysToDisplayMap: Record<TBCTXKeys, string>;
};
export type TBctxItem = {
  v: string;
  k: TBCTXKeys;
};

export type TBctxItemWithoutSize = {
  v: string;
  k: TBCTXKeysWithoutSize;
};
export type TBctxChangeEventSizeInfo = {
  newSize?: string;
  oldSize?: string;
};
type TBctxDatetime = {
  date: string;
  datetime: number;
};

type TSrcIds = {
  search_id: any;
};

type TBctxValues = {
  qty: number;
  shippable_quantity?: number;
};

type TBCTXData = {
  bctx_type: TBCTXType;
  bctx_items: TBctxItem[];
  bctx_values: TBctxValues; // order quantity
  subject: any;
  subjects: string[];
  bctx_name: string;
  bctx_datetime: TBctxDatetime;
  src_ids: TSrcIds;
  wip_qty: number;
};

export type TWIPBusinessData = TBCTXData & {
  bctx_type: 'wip';
  wip_qty: number;
  hsk: string;
  datetime: number;
  last_seen: number;
};

export type TOrderBusinessData = TBCTXData & {
  bctx_type: 'order';
  wip_qty: number;
  hsk: string;
  datetime: number;
  last_seen: number;
};

export type TPlanBusinessData = TBCTXData & {
  bctx_type: 'plan';
  aux: { [key: string]: any }; // TODO: change any type here
  bctx_datetime: {
    key: TBctxDatetime;
  };
};

export type TUnknownBusinessData = TBCTXData & {
  bctx_type: 'unknown';
};

export type TBusinessContextData = TWIPBusinessData | TOrderBusinessData | TPlanBusinessData | TUnknownBusinessData;

export type TREQUEST_BusinessContextRequestDTO = {
  subject_key: string;
  bctx_name: string;
  hsk: string;
  context: string;
  datetime: number;
  subjects: string[];
  bctx_type: TBCTXType;
  compress: boolean;
  agg_type: string;
  bctx_keys: string[];
  server_wip_validation_enabled: boolean;
  window: number[];
};
export type TRESPONSE_BusinessContextData = TBusinessContextData[];

export type TREQUEST_GetIncompleteBundles = {
  app_type: string;
  domerole: string;
  hsk: string;
  sub_id: string;
  subject_key: string;
};
export type TRESPONSE_GetIncompleteBundles = {
  result: TIncompleteBundle[];
};

export type TREQUEST_UpdateIncompleteBundles = {
  app_type: string;
  data: TIncompleteBundle[];
  domerole: string;
  hsk: string;
  sub_id: string;
  subject_key: string;
};

export type TRESPONSE_UpdateIncompleteBundles = {
  result: any;
};

// export type TBusinessContextListingItemFilterType = 'BUYER' | 'PO' | 'STYLE' | 'COLOR' | 'PRODUCT_TYPE' | 'PRODUCT_CATEGORY' | "ORDER_REF";

// export const BusinessContextListingItemFilterTypeToDSMap: Record<
//   TBusinessContextListingItemFilterType,
//   TBCTXKeysWithoutSize
// > = {
//   BUYER: 'buyer',
//   PO: 'po',
//   STYLE: 'style',
//   PRODUCT_TYPE: 'product_type',
//   COLOR: 'color',
// };

export type TBusinessContextListingItemFilter = {
  filterType: TBCTXKeysWithoutSize;
  values: (string | number)[];
};

export type TMultipleRoundsDefectivesListingItemFilter = {
  filterType: TBCTXKeysWithoutSize;
  values: (string | number)[];
};

export type TPerPieceLineTransactionsListingItemFilter = {
  filterType: TBCTXKeys;
  values: (string | number)[];
};

export type TRoamingQcTransactionsListingItemFilter = {
  filterType: TBCTXKeys;
  values: (string | number)[];
};

export type TBusinessContextListingItem = {
  buyer: string;
  style: string;
  po: string;
  color: string;
  product_type: string;
};

type TCacheTimeDTO = {
  i: number;
  o: number;
};

export type TEventTimeDTO = {
  dt: number; // datetime
  tz: string; // timezone
  os: number; // timzone offset
  cc?: TCacheTimeDTO; // const
  src_dt?: number; // const
};

export type TCTXDTO = {
  k: string;
  v: string;
  h?: boolean;
  d?: string;
  ctx?: number;
  g?: boolean;
};

type THSK = 'primary' | 'secondary' | 'secondary1' | 'tertiary' | 'quaternary' | 'quinary' | '';

type TEventAux = {
  gid?: string;
  rnd?: number;
  snm?: string | null;
  hsk: THSK;
  dnm: string; // subject name
  dnr: string; // subject gate value ( dom role )
  smv?: number;
};

type TTag = {
  shift: string;
  shift_dn: string;
  team?: string;
  audit_id?: string;
  audit_cycle?: number;
  audit_cycle_id?: string;
  audit_disName?: string;
  operator_id?: string;
  operation?: string;
  re_audit_id?: string;
  search_id: string | null;
  status?: string;
  src_ids: { [key: string]: string | null | number };
  pt_id?: string;
  res_subject?: string;
  res_dn?: string;
  source_name?: string;
  search_dn: string | null;
  record_category?: string;
};
type TNum = {
  sample_qty?: number;
  pass?: number;
  fail?: number;
  defects?: number;
  qty?: number;
  rqty?: number;
  bqty?: number;
  wqty?: number;
};
type TEventECX = {
  num?: TNum;
  tag: TTag;
};

export type TEventWhere = {
  ad: string; // agent id ( device id)
  at: string; // subject + app name (app type)
  ur: {
    id: string; // username
    nm: string; // user first name
  };
  epf: string; // empty string ( backend expect empty string)
  an: string; // app name
  av: string; // app version
  mi?: string; // message id : time and sequence id
  es?: string; // no-es
};

export type TEventAboutDTO = {
  sub: string;
  ctx: TCTXDTO[];
  aux: TEventAux; // details of current station
  ecx: TEventECX;
  snm: string; // subject display name
  dnrk: string; // subject gate key
  wip_override_ctx?: TCTXDTO[]; // current bctx for which wip should be reduced in PO Split
};

type TEventIdentity = {
  dt: number; // dateTime.getTime();
  id: number; // window['sp_seq'] + 1;
};

type TSizeDetails = {
  name: string;
  a_ctx: number; // TODO: aCtx = 1
};

export type TOperationDetails = {
  category_id: string;
  name: string;
  group_name: string;
  value?: number;
  display: boolean;
  department?: string;
};

export type TIssueDetails = {
  category_id: string;
  name: string;
  status?: boolean;
  category?: TGenericIssueDTO['category'];
};

export type TSilhouetteDetails = {
  x: number;
  y: number;
  image: string;
  shillohutte_id?: string;
};

export type TACDetails = {
  size?: TSizeDetails;
  action?: string;
  actual?: TCTXDTO[];
  operation?: TOperationDetails; //null in checkin and ftt
  issues?: TIssueDetails | TMasterdataItemInfo[]; //null in checkin and ftt
  silhouette?: TSilhouetteDetails; //null in checkin and ftt
  row_id?: number;
  status?: string;
  row_pass?: number;
  row_fail?: number;
  row_sample?: number;
  row_qty?: number;
  pass_measurement?: TMeasurement_issue[];
  fail_measurement?: TMeasurement_issue[];
};

type TResultData = {
  category_id: string;
  group_id: string;
  name: string;
  id: string;
  operation: string;
  status: boolean;
};

type TResultElement = {
  operation: string;
  category_id: string;
  size: string;
  date: string;
  id: string;
  data: TResultData;
};

type TRF = {
  ac: TACDetails[]; //should be empty
  result: TResultElement[];
};

export type TAqlLevel = {
  aql_level_buyer: string;
  aql_level: string;
  aql_level_lot_range_start: string;
  aql_level_lot_range_end: string;
  aql_level_sample: string;
  aql_level_pass_qty: string;
  aql_level_fail_qty: string;
};

export type TEventWhat = {
  ac: TACDetails[] | Record<TMemberAdditionType, number>;
  ty: string;
  nm: string;
  vl: number;
  cv: number;
  rf?: TRF | null;
  dv?: boolean;
  defective_image_id?: TBucketId;
  aql_level_details?: TAqlLevel;
  ad: string; // Device ID
};

type TEventValueDTO = {
  v_id: string; // client generated  new Date().getTime() + '_' + Math.random().toString(36).substr(2);
  w1: TEventTimeDTO; // When
  a: TEventAboutDTO; // about
  w2: TEventWhere; // Who
  ei: TEventIdentity; // event identifier
  w3: TEventWhat; // what
  unique_event_id: string;
  linked_event_id?: string;
};

type TEventDTO = {
  key: string;
  value: TEventValueDTO;
};

export type TWipFailureInfo = {
  failure_type: 'WIP_VALIDATION';
  reason: 'WIP_VALIDATION';
};
export type TNextProcessInfoType = {
  department: string;
  dom_role: string;
};

export type TPPTValidationType =
  | 'INVALID_UNDO'
  | 'ORIGINAL_UNDO_EVENT_NOTFOUND'
  | 'DUPLICATE_EVENT'
  | 'TAG_NEVER_SCANNED'
  | 'INVALID_PROCESS_ON_TOP_OF_DEFECTIVES'
  | 'CURRENT_PROCESS_NOT_FOUND_IN_CONFIG'
  | 'PREVIOUS_STATE_NOT_FOUND'
  | 'MASTER_BUNDLE_NOT_OUT_OF_CUTBANK_OUT'
  | 'INVALID_EVENT_FOR_PREVIOUS_STATE';

export type TPerPieceFailureInfo = {
  failure_type: 'PER_PIECE_TAG_VALIDATION';
  reason: string;
  ppt_failure_info?: {
    ppt_validation_type: TPPTValidationType;
    next_process_info: TNextProcessInfoType;
    department?: string;
    dom_role?: string;
    line_number?: string;
    tag_id?: string;
    bundle_id?: string;
    event_name?: string;
    event_time?: number;
  };
};

export type TServerErrorFailureInfo = {
  failure_type: 'SERVER_ERROR';
  reason: string;
};

export type TSourceEventFailureInfo = {
  failure_type: 'SOURCE_EVENT_VALIDATION';
  reason: 'SOURCE_EVENT_VALIDATION';
};

export type TFailureInfo = TWipFailureInfo | TPerPieceFailureInfo | TSourceEventFailureInfo | TServerErrorFailureInfo;

export type TEventValidation = {
  mi: string;
  v_id: string;
  pt_id: string;
  valid: boolean;
  value: number;
  event_value: number;
  event_name: string;
  cv: number;
  failure_info?: TFailureInfo;
};

export type TREQUEST_AppEventsRequestDTO = {
  records: TEventDTO[];
  subject_key: string;
  datetime: number;
  server_validation: boolean;
  qty_validation: string;
  wipType: string; // bctx_name
};

export type TRESPONSE_AppSaveEvents = {
  requestId: string;
  records: TEventValidation[];
};

type TAgent = {
  subject: string;
  hsk: string;
};

type TState = {
  date: string;
  combinations: {
    [key: string]: object;
  };
  commonsizelist: {
    [key: string]: object;
  };
};

export type TBctxLevelSyncedState = {
  size: string;
  remainingWipQty: number;
  actualsCount: TActualsCount;
};

type TSyncedStateData = {
  bctxLevelSyncedStates: TBctxItemAndSyncedStateSize[];
};

type TAppSyncedState = {
  syncedStateBySubject: {
    [key: string]: TSyncedStateData;
  };
};

type TActualsCount = {
  checkin: number;
  ftt: number;
  reject: number;
  defectives: number;
  rectified: number;
  reject_r: number;
};

type TActualsCountWithSize = {
  size: string;
  actuals: TActualsCount;
};

type TBctxLevelActuals = {
  bctx: string;
  actualsBySize: TActualsCountWithSize[];
};

type TActualsInfo = {
  agent: TAgent;
  aggregatedActuals: TActualsCount;
  bctxlevelActuals: TBctxLevelActuals[];
};

export type TBctxItemAndSyncedStateSize = {
  preSizeLevelBctx: TBctxItemWithoutSize[];
  sizes: TBctxLevelSyncedState[];
};

export type TREQUEST_RestoreRequest = {
  date: string;
  appType: string;
  agents: TAgent;
  subjectKey: string;
  wip_type: string;
  orderedBctxFields: TBCTXKeys[];
  wip_validation: string;
  shift_id: string;
  bctx_items: TBctxWithMultipleSize[];
};

export type TRESPONSE_AppStateResponse = {
  result: TState;
  appSyncedState: TAppSyncedState;
  actuals: TActualsInfo[];
  skipBackendState: boolean;
  requestId: string;
};

export type TREQUEST_RestoreRequestForBackedUpBctx = {
  date: string;
  appType: string;
  agentAndShiftForActualsAndWIP: {
    agent: TAgent;
    shift_id: string;
  };
  agents: TAgent[];
  shift_ids: string[];
  subjectKey: string;
  wip_type: string | null;
  orderedBctxFields: TBCTXKeys[];
  restore_total_checkins?: {
    delivery_date_range: {
      from: number;
      to: number;
    };
  };
};

export type TRESPONSE_AppStateResponseForBackedUpBctx = {
  appSyncedState: {
    bctxLevelSyncedStates: TBctxItemAndSyncedStateSize[];
  };
  skipBackendState: boolean;
  requestId: string;
  agentToShiftWiseBctx: {
    agent: TAgent;
    shiftWiseBctxs: {
      bctx: TBctxWithMultipleSize[];
      shiftId: string;
    }[];
  }[];
  bctxLevelTotalCheckins?: TBctxLevelTotalCheckins[];
};

// custom types

export type TActualType =
  | 'CHECK_IN'
  | 'FTT'
  | 'REJECTED'
  | 'IN_PROGRESS'
  | 'TO_BE_RECTIFIED'
  | 'REWORKED_FROM_DEFECTIVE'
  | 'REJECTED_FROM_DEFECTIVE'
  | 'DEFECTIVE';

export type TMDPointGradingPageAction = 'FTT' | 'IN_PROGRESS' | 'REJECTED' | 'CHECK_IN';
export type TQCGradingPageAction = 'FTT' | 'DEFECTIVE' | 'REJECTED';
export type TLineInGradingPageAction = 'CHECK_IN';
export type TGradingPageAction = TQCGradingPageAction | TMDPointGradingPageAction | TLineInGradingPageAction;
export type TQcLineInGradingPageAction = TQCGradingPageAction | TLineInGradingPageAction;
export type TToBeRectifiedSaveEventActionType = 'REWORKED_FROM_DEFECTIVE' | 'REJECTED_FROM_DEFECTIVE';

export type TMDPointActionItem = {
  type: 'FTT' | 'REJECTED' | 'IN_PROGRESS' | 'TO_BE_RECTIFIED';
  displayName: string;
  totalActuals: number;
};

export type TQcActionItem = {
  type: 'FTT' | 'REJECTED' | 'REWORKED_FROM_DEFECTIVE' | 'DEFECTIVE';
  displayName: string;
  totalActuals: number;
};

export type TCheckInActionItem = {
  type: 'CHECK_IN';
  displayName: string;
  totalActuals: number;
};

export type TActionItemType = TCheckInActionItem['type'] | TQcActionItem['type'];

export type TPerPieceQcCurrentActionInfo = {
  actionType: TQcActionItem['type'];
  isRecentDefectives: boolean;
  displayName: string;
  isBulkScan: boolean;
};

export type TActionTypeToTotalMap = { [key in TActualType]: number };

export type TClientWorkItem = {
  actuals: number;
  displayName: string;
};

export type TClientWork = {
  [key in TActualType]: TClientWorkItem;
};

export type TSizeMapItem = {
  name: string;
  client_work: TClientWork;
  isInactive?: boolean | undefined;
};

export type TSizeMap = {
  [key: string]: TSizeMapItem;
};

export type TClient_BCTX_Item = {
  bctx_key: string; // combination of buyer , po ,  style , color, product_type
  sizeMap: TSizeMap;
};

export type TClient_BCTX = {
  [key: string]: TClient_BCTX_Item;
};

export type TBctxHeaderItem = {
  label: string;
  value: string;
  textColor?: string;
};

export type TCountEvent = {
  bctxKey: string;
  sizeName: string;
  count: number;
};

export type TSizeAndCount = {
  name: string;
  count: number;
};

export type TUniqueIdToCountEventMap = {
  [key: string]: TCountEvent;
};

export type TToBeRectifiedCountEvent = {
  toBeRectifiedDTO: TToBeRectifiedDTO;
  countEvent: TCountEvent;
  rectifiedTime: number;
};
export type TUniqueIdToBeRectifiedDTOMap = {
  [key: string]: TToBeRectifiedCountEvent;
};

export type TSelectedStationIdAndShiftId = {
  stationId: string;
  shiftId: string;
};

export type TSizeInfo = {
  name: string;
  order_qty?: number; // TODO: maybe added later
  wip_qty: number;
  isInactive?: boolean | undefined;
};

export type TSizeToWipMapItem = {
  [size: string]: TSizeInfo;
};

export type TBctxWipMapItem = {
  bctxItemListWithoutSize: TBctxItemWithoutSize[];
  sizeToWipMap: TSizeToWipMapItem;
  bctxKey: string;
  isInactive?: boolean | undefined;
  filteredSizesList: string[];
};

export type TBctxWipMap = {
  [bctx_key: string]: TBctxWipMapItem;
};

export type TShiftMapItem = {
  clientBctx: TClient_BCTX;
  rectifiedBCTXKeysInfo: Record<string, TRectifiedBCTXInfo>;
};

export type TShiftMap = {
  [shift_id: string]: TShiftMapItem;
};
export type TSelectedBctxInfo = {
  bctxInfoWithoutSize: TBctxItemWithoutSizeAndBctxKey;
  size?: string; //only available for per-piece apps
  newBctxForPOSplit?: TNewBctxItemInPOSplit;
};
export type TLineMapItem = {
  bctxWipMap: TBctxWipMap;
  shiftMap: TShiftMap;
  selectedBctxInfo: TSelectedBctxInfo;
};

export type TBctxMinMaxDateTime = {
  minDate: number | null;
  maxDate: number | null;
};

export type TBctxPlanBasedItem = {
  bctxItemListWithoutSize: TBctxItemWithoutSize[];
  bctxKey: string;
};

export type TPlanBasedLineMapItem = {
  [bctx_key: string]: TBctxPlanBasedItem;
};

export type TAllBctxItems = {
  [bctx_key: string]: TBctxItemWithoutSize[];
};

export type TLineMap = {
  [key: string]: TLineMapItem;
};
export type TPlanBasedLineMap = {
  [key: string]: TPlanBasedLineMapItem;
};

export type TLineMapCreationItems = {
  bctxItemListWithoutSize: TBctxItemWithoutSize[];
  size: string;
  bctx_key: string;
  wip_qty: number;
};
export type TCommonLockedBy =
  | 'RECONCILE'
  | 'BCTX_SYNCING'
  | 'RESTORE_ACTUALS_AND_WIP'
  | 'RESTORE_TO_BE_RECTIFIED_COUNTS'
  | 'POLLING_FOR_BG_LOCK'
  | 'INIT_PENDING'
  | 'RE_SYNC_FAILED_EVENTS';
export type TUserDBLockedBy =
  | TCommonLockedBy
  | 'NONE'
  | 'SYNCING_EVENTS'
  | 'EVENT_ADDITION'
  | 'LINE_OR_SHIFT_CHANGE'
  | 'LOAD_DEFECT_LIST_MD_POINT'
  | 'VALIDATING_UNDO'
  | 'CLEARING_IN_PROGRESS_DETAILS_FOR_ROAMING_QC'
  | 'UPDATING_EPF_DETAILS_FOR_ROAMING_QC'
  | 'CLEAR_DEFECT_LIST_MD_POINT'
  | 'BULK_RECEIVE_INIT'
  | 'UPDATING_INCOMPLETE_BUNDLES'
  | 'BULK_COUNT_TRANSACTION_SYNC'
  | 'FETCHING_INCOMPLETE_BUNDLES'
  | 'SYNCING_DEFECTIVE_IMAGES'
  | 'PENDING_WORK_ADDITION'
  | 'PENDING_WORK_ADDITION'
  | 'POPULATE_LINEMAP_PLANBASED'
  | 'UPDATE_SIZE_LIST_IN_LINEMAP'
  | 'UPDATING_FILTERED_SIZES_LIST_IN_LINEMAP';

export type TUserDBLockResult =
  | {
      status: 'SUCCESS';
      lockedBy: TUserDBLockedBy;
    }
  | {
      status: 'FAILURE';
      lockedBy: TUserDBLockedBy;
      message: string;
    };

export type TCacheResetTimestampDB = {
  nextCacheResetTimestamp: number;
};

export type TBackUpDataStatusDB = {
  status: boolean;
};

export type TBgShiftMapItem = {
  clientBctx: TClient_BCTX;
};
export type TBgShiftMap = {
  [shift_id: string]: TBgShiftMapItem;
};
export type TBgLineMapItem = {
  bctxWipMap: TBctxWipMap;
  shiftMap: TBgShiftMap;
};
export type TBgLineMap = {
  [line: string]: TBgLineMapItem;
};
export type TPastDaysDefectivesInfo = {
  [gId: string]: TPastDaysDefective[];
};
export type TPastDaysBackgroundEventsSyncInfo = {
  [bctxKey: string]: {
    syncTime: number;
  };
};
export type TPerPiecePastDaysEventsInfo = {
  [bctx_key: string]: TPerPieceQcPastDaysEvent[];
};
export type TBackgroundEventsSyncingDB = {
  dailyCache: {
    nextCacheResetTimestamp: number;
    lineMap: TBgLineMap;
    ppLineMap: {
      [line: string]: {
        lineInfo: {
          [shift_id: string]: {
            clientWork: TClientWork;
          };
        };
      };
    };

    events: {
      list: TBulkEventBackgroundData[];
    };
  };
  persistanceCache: {
    pastDaysList: TBulkEvent[];
    nextEventId: number;
    bulkQcPastDaysDefectives: TPastDaysDefectivesInfo;
    pastDaysBackgroundEventsSyncInfo: TPastDaysBackgroundEventsSyncInfo;
  };
};
export type TPastDaySyncedEventsDB = {
  listOfPastDaysEventsWhichAreSynced: TActivityLogEvent[];
};
export type TPerPieceQcPastDaysEvent = TPastDaysNonDefective | TPastDaysDefective;
export type TPastDaysNonDefective = {
  v_id: string;
  eventType: 'FTT' | 'UNDO_FTT' | 'REJECTED' | 'UNDO_REJECTED';
  eventTime: number;
  syncedTime?: number;
  status: TYET_TO_BE_SYNCED | TSycedEventStatus;
};
export type TPastDaysDefective = {
  v_id: string;
  eventType: TDefectiveReleatedEvent['actionType'];
  eventTime: number;
  round: number;
  syncedTime?: number;
  status: TYET_TO_BE_SYNCED | TSycedEventStatus;
};

export type TBulkEventBackgroundData = {
  backgroundMetadata: TBulkEventBackgroundMetadata;
  events: TEventBackgroundMetadata[];
};
export type TBgDBLockedBy = TCommonLockedBy | 'NONE' | 'SYNC_EVENTS';

export type TReSyncEventsDayType = 'PAST_DAYS' | 'CURRENT_DAY';

export type TBgDBLockResult =
  | {
      status: 'SUCCESS';
      lockedBy: TBgDBLockedBy;
    }
  | {
      status: 'FAILURE';
      lockedBy: TBgDBLockedBy;
      message: string;
    };
export type TBgEventsSyncingDBLockDetails = {
  lockedBy: TBgDBLockedBy;
  isLocked: boolean;
  metadata: {
    SYNC_EVENTS: {
      nextLockUpto?: number;
    };
  };
};
export type TUserActualsDBLockDetails = {
  lockedBy: TUserDBLockedBy;
  isLocked: boolean;
};

export type TInputAppStore = {
  userDBLockDetails: TUserActualsDBLockDetails;
  toBeRectifiedListing: {
    response?: TRESPONSE_ToBeRectifiedListing;
  };
  perPieceTransactions: {
    response?: TRESPONSE_GET_PER_PIECE_LINE_IN_TRANSACTIONS;
  };
  perPieceQcCurrentActionInfoMap: Record<string, TPerPieceQcCurrentActionInfo>;
  userDB: TUserActualsDB;
  bgDBLockDetails: TBgEventsSyncingDBLockDetails;
  bgDB: TBackgroundEventsSyncingDB;
};
export type TBctxItemWithoutSizeAndBctxKey = {
  list: TBctxItemWithoutSize[];
  bctxKey: string;
  isInactive?: boolean | undefined;
};

export type TLastBctxChangeEventData = {
  size: string;
  bctxItemWithoutSizeAndBctxKey: TBctxItemWithoutSizeAndBctxKey;
};

export type TVariableGroupFieldsInfo = {
  variableFieldName: string;
  currentVariableFieldValue: string;
  newVariableFieldValue: string;
};

export type TIncompleteBundlesInfoLineMap = {
  [line: string]: {
    [shift: string]: {
      lastUpdatedAt: number;
      list: TIncompleteBundle[];
    };
  };
};

export type TBctxItemWithSize = {
  bctx: TBctxItemWithoutSize[];
  size: string[];
};

export type TBctxKeyToBctxItemWithSizeMap = {
  [bctxKey: string]: TBctxItemWithSize;
};

export type TUserActualsDB = {
  dailyCache: {
    lastStyleSyncInfoTimestamp: number | undefined;
    nextCacheResetTimestamp: number;
    bctxMinMaxDateTime: TBctxMinMaxDateTime;
    lineMap: TLineMap;
    ppLineMap: {
      [line: string]: {
        lineInfo: {
          [shift_id: string]: {
            bctx: TBctxItemWithSize[];
            clientWork: TClientWork;
          };
        };
        selectedBctxInfo: TSelectedBctxInfo;
        ps: TBctxItemWithoutSize[][];
      };
    };
    planBasedLineMap: TPlanBasedLineMap;
    events: {
      list: TBulkEventWithoutStatus[];
    };
    bulkMdPointEvents: TSingleCountEvent[];
  };
  persistanceCache: {
    incompleteBundlesInfo: {
      [line: string]: {
        [shift: string]: {
          lastUpdatedAt: number;
          list: TIncompleteBundle[];
        };
      };
    };
  };
};

export type TStationDetails = {
  shiftId: string;
  subjectKey: string;
  subject: string;
  hsk: string;
  domerole: string;
};

type TFilterToBeRectifiedType = 'SIZE' | 'BUYER' | 'PO' | 'STYLE';

type TFilterToBeRectified = {
  filterType: TFilterToBeRectifiedType;
  values: (string | number)[];
};

export type TREQUEST_ToBeRectifiedListing = {
  stationDetails: TStationDetails;
  filters: TFilterToBeRectified[];
  pageNo: number;
  pageSize: number;
  selectedBctxItem?: Record<TBCTXKeysWithoutSize, string>;
};
export type TBackendToBeRectifiedDTO = {
  datetime: string;
  key: string;
  bctx: Record<TBCTXKeysWithoutSize, string>;
  size: string;
};

export type TToBeRectifiedDTO = {
  datetime: number;
  key: string;
  bctx: TBctxItemWithoutSize[];
  size: string;
};

type TBCTXFields = {
  key: TBCTXKeys;
  value: string;
};

export type TRESPONSE_ToBeRectifiedListing = TRESPONSE_ToBeRectifiedListingCommon & {
  records: TToBeRectifiedDTO[];
};

export type TRESPONSE_ToBeRectifiedListingCommon = {
  selectedFilters: TFilterToBeRectified[];
  supportedFilters: TFilterToBeRectified[];
  paginationInfo: TPaginationInfo;
};

export type TRESPONSE_BackendToBeRectifiedListing = TRESPONSE_ToBeRectifiedListingCommon & {
  records: TBackendToBeRectifiedDTO[];
};

export type TREQUEST_ServerDefectives = {
  app_type: string;
  hsk: string;
  sub_id: string[];
  date: string;
  subject_key: string;
  domerole: string;
  refactor: boolean;
};

export type TRESPONSE_ServerDefectives = {
  data: {
    [subject: string]: {
      bctx_vid: string;
      ctx: {
        k: TBCTXKeysWithoutSize;
        v: string;
        h: boolean;
        g: boolean;
        ctx: number;
      }[];
      defect_status: string;
      event_ac: TACDetails[];
      id: string;
      key: string;
      round: number;
      size: string;
      result: any;
      defective_image_id: TBucketId | null;
      datetime: string;
    }[];
  };
  domerole: string;
  hsk: string;
  sub_id: string[];
};

export type TRectifiedBCTXInfo = {
  key: string;
  rectifiedTime: number;
};

export type TBctxWithMultipleSize = {
  preSizeLevelBctx: TBctxItemWithoutSize[];
  sizes: string[];
};
export type TBctxLevelTotalCheckins = {
  bctx: string;
  totalCheckinsBySize: {
    size: string;
    checkin: number;
  }[];
};

export type TBctxWithMultipleSizeAndCount = {
  preSizeLevelBctx: TBctxItemWithoutSize[];
  sizes: TSizeAndCount[];
};

export type TBctxWithMultipleSizeToBeRectifiedCounts = {
  preSizeLevelBctx: TBctxItemWithoutSize[];
  sizeToCountMap: {
    [key: string]: {
      todaysToBeRectifiedCount: number;
      totalToBeRectifiedCount: number;
    };
  };
};

export type TREQUEST_RestoreToBeRectifiedCounts = {
  stationDetails: TStationDetails;
  bctxItems: TBctxWithMultipleSize[];
};

export type TRESPONSE_RestoreToBeRectifiedCounts = {
  bctxItems: TBctxWithMultipleSizeToBeRectifiedCounts[];
};

export type TREQUEST_BACK_UP = {
  date: string;
  appType: string;
  subjectKey: string;
  agentToShiftWiseBctx: TAgentToShiftWiseBctx[];
};

export type TRESPONSE_BACK_UP = {};

export type TShiftWiseBctx = {
  shiftId: string;
  bctx: TBctxWithMultipleSize[];
};

export type TAgentToShiftWiseBctx = {
  agent: {
    subject: string;
    hsk: string;
  };
  shiftWiseBctxs: TShiftWiseBctx[];
};

export type TRESPONSE_UPLOAD_PHOTOS =
  | {
      result: 'Success';
      urls: string[];
    }
  | {
      result: 'Failure';
      message: string;
    };

export type TREQUEST_GET_IMAGE_URLS_BY_IDS = {
  imageIds: TBucketId[];
};

export type TRESPONSE_GET_IMAGE_URLS_BY_IDS = {
  result: 'Success';
  urlMap: {
    [key: TBucketId]: string[];
  };
};

export type TUserAction = {
  chainWithReFetchWip?: boolean;
  chainWithRestoreWipAndActualsForBackedUpBctx?: TRestoreBackedUpBctx;
  chainWithUndo?: TUndoDTO;
  chainWithInitForLineChange?: TLineChangeActions;
  chainWithSyncWipForBackground?: TLoadBctxMoreActions;
  chainWithReFetchServerDefectives?: boolean;
  chainWithPerPieceLineInUndo?: TPerPieceLineInUndoDTO;
  chainWithPerPieceQcUndo?: TPerPieceQcUntoDTO;
  chainWithLogout?: boolean;
  chainWithAppUpdate?: TRemoteDeploymentCheck;
  reconcileAndShowAppUpdateError?: TRemoteDeploymentCheckWithEventsSyncResult;
  chainWithLoadBctxAndChainActions?: { moreActions: TLoadBctxMoreActions; chainActions: TLoadBctxSideActions };
};

export type TBgEventSyncErrorStatus =
  | 'NO_INTERNET_FOR_SYNCING_PENDING_EVENTS'
  | 'SYNCING_PENDING_EVENTS_FAILED'
  | 'ALL_SYNCED_WITH_VALIDATION_ERRORS';

export type TBgEventSyncResult = {
  status: 'ALL_SYNCED' | TBgEventSyncErrorStatus;
};

export type TRemoteDeploymentCheckWithEventsSyncResult = {
  remoteDeploymentcheck: TRemoteDeploymentCheck;
  syncResult: TBgEventSyncResult;
};

export type TSyncEventsAction = {
  showLoaderWithMessage: string;
  showLockFailure: string;
  batchCount: number;
  showFailedEvents: boolean;
  chainAction?: TUserAction;
};
export type TPerPieceDefectOrRejectAdditionDTO = {
  size: string;
  bctxItemListWithoutSize: TBctxItemWithoutSizeAndBctxKey;
  linked_event_id?: string;
  actionType: TPerPieceEventAdditionSideActionType;
};
export type TPerPieceEventAdditionSideActionType = 'DEFECTIVE' | 'REJECT';
export type TShowExistingPerPieceDefectiveDTO = {
  defectiveWithLinkedVId: TPerPieceDefectiveInfoWithLinkedVId;
  bctxItems: TBctxItemWithoutSize[];
  size: string;
};
export type TEventAddtionSideActions = {
  showToastForEventsAddition?: boolean;
  closeModal?: boolean;
  syncIncompleteBundles?: {
    closeModal: boolean;
  };
  roamingQcAuditAddition?: { toBeClosedModals: number };
  perPieceDefectOrRejectAddition?: TPerPieceDefectOrRejectAdditionDTO;
  showPerPieceDefective?: TShowExistingPerPieceDefectiveDTO;
};

export type TEventAddtionMoreActions = {
  updateIncompleteBundles?: TIncompleteBundlesInfo;
  clearSelectedBctxAndUpdateIncompleteBundles?: {
    incompleteBundlesInfo: TIncompleteBundlesInfo;
  };
  clearSelectedBctx?: boolean;
  updateSelectedBctx?: TSelectedBctxInfo;
  updateActualsOnly: boolean;
  syncDataWithBackend?: boolean;
};

export type TLoadBctxSideActions = {
  chainWithLoadMasterdataLists?: boolean;
  chainWithRestoreBackedUpBctxAndThenLoadMasterdataList?: TRestoreBackedUpBctx;
  chainWithRestoreActualsForNewStyles?: boolean;
  chainWithBctxChangeEvent?: boolean;
};

export type TLoadBctxSideActionsPlanBased = {
  chainWithLoadNewSizes?: boolean;
  chainWithLoadAllMasterDataList?: boolean;
  masterDataListMetaData?: TMasterDataListMetaData;
};

export type TLoadBctxMoreActions = {
  discardWipUpdates: boolean;
};

export type TClientDBInitInfo = {
  isInit: boolean;
  isReload: boolean;
  isDayEnd: boolean;
  userDB: TUserActualsDB;
  bgDB: TBackgroundEventsSyncingDB;
};

export type TLineChangeActions = {
  actions?: TLoadBctxSideActions | TLoadBctxSideActionsPlanBased;
  isPlanBasedApp?: boolean;
};

export type TREQUEST_RoamingQcTransactions = {
  compressed: false;
  window: string;
  dates: string[];
  subject: string;
  subject_key: string;
  columns: TBCTXKeys[];
  hsk: string;
};
export type TRESPONSE_RoamingQcTransactions = {
  ctx: TBctxItem[];
  cycle_id: string;
  dateTime: number;
  id: string;
  operation: { name: string };
  operator: string;
  record_category: 'complete' | '';
  round: number;
  shift: string;
  samples: TSampleModel[];
  status: 'green' | 'yellow' | 'red';
  subject: string;
}[];

export type TAppIdentifier =
  | 'fabric_inspection'
  | 'md_point_v2'
  | 'endline_qc_v2'
  | 'bundle_qc_v2'
  | 'bundle_line_in_v2'
  | 'packing_v2'
  | 'roaming_qc_v2'
  | 'per_piece_line_in_v2'
  | 'per_piece_washing_in_v2'
  | 'per_piece_washing_out_v2'
  | 'line_in_v2'
  | 'per_piece_qc_v2'
  | 'md_point_per_piece_qc_v2'
  | 'bulk_washing_in_v2'
  | 'bulk_washing_out_v2'
  | 'aql_v2'
  | 'cpi'
  | 'cutbank_in_v2'
  | 'cutbank_out_v2'
  | 'plan_qc_v2'
  | 'trim_inspection'
  | 'component_line_in'
  | 'assembly_in'
  | 'wip_packer_v2'
  | 'tv_dashboard_v2'
  | 'embellishment_in_v2'
  | 'embellishment_out_v2'
  | 'measurement_qc'
  | 'set_packs'
  | 'carton_packing';

// export type TTagHistoryArgDs = {
//   key: '@ds';
//   value: string;
// };

// export type TTagHistoryArgOffset = {
//   key: '@offset';
//   value: string;
// };

// export type TTagHistoryArgSk = {
//   key: '@sk';
//   value: string;
// };

// export type TTagHistoryArgStore = {
//   key: '@store_name';
//   value: string;
// };

// export type TTagHistoryArgTagId = {
//   key: '@tag_id';
//   value: string;
// };

// export type TTagHistoryArgWindow = {
//   key: '@window';
//   value: string;
//   n: number;
// };

// export type TTagHistoryArgs =
//   | TTagHistoryArgDs
//   | TTagHistoryArgOffset
//   | TTagHistoryArgSk
//   | TTagHistoryArgStore
//   | TTagHistoryArgTagId
//   | TTagHistoryArgWindow;

// export type TTagHistoryModalConfig = {
//   args: TTagHistoryArgs[];
//   icon: string;
//   name: string;
//   next_view_ref: string;
//   notification: boolean;
//   request_id: 'tag_history_search_request'; // should be enum
//   summary_names: (keyof TTagHistoryDetails)[];
//   summary_props: (keyof TTagHistoryDetails)[];
// };

// export type TReceieverSubject = {
//   bctx_ref: string[];
//   dis_name: string;
//   filter_type: string;
//   gatek: string;
//   gatev: string;
//   hsk: string;
//   key: string;
//   name: string;
//   oss_sub: string;
//   subject: string;
// };

// export type TTagHistoryDetails = {
//   bundle_no: string;
//   buyer: string;
//   color: string;
//   cut_no: string;
//   line: string;
//   order_ref: string;
//   po: string;
//   product_type: string;
//   receiver_subject: TReceieverSubject;
//   shade: string;
//   size: string;
//   style: string;
//   tagDisplayId: string;
//   tagQty: string;
//   tag_id: string;
// };

// export type TTagHistoryDTO1 = {
//   app: string;
//   datetime: Date;
//   details: TTagHistoryDetails;
//   dn: string;
//   line: string;
//   qty: number;
//   status: string;
//   subject: string;
//   user: string;
// };

// export type TTagHistoryDTO2 = {
//   bundle_no: string;
//   checkin: number;
//   color: string;
//   completed: number;
//   date: string;
//   domRole_dn: string;
//   grouped_timing: string;
//   module_id: string;
//   po: string;
//   product_type: string;
//   qty: number;
//   search_id: string;
//   size: string;
//   status: string;
//   style: string;
//   time: string;
//   details?: TTagHistoryDetails;
// };

// // export type TRESPONSE_TTagHistory = {
// //   tag_history_search_request: TTagHistoryDTO[]
// // }

// export type TREQUEST_TTagHistory = {
//   req_args: TTagHistoryArgs[];
//   req_id: TTagHistoryModalConfig['request_id'];
// };

export type TREQUEST_DevicePendingEventsSyncStatusBeforeLogoutAck = {
  subjectKey: string;
  subjects: string[];
  deviceId: string;
  hsk: string;
  domrole: string;
  pendingEventsCount: number;
  syncStatus: 'START' | 'END';
};

export type TRESPONSE_DevicePendingEventsSyncStatusBeforeLogoutAck = {
  status: String;
};

export type TTagInfo = {
  k: string;
  v: string | number;
};
export type TREQUEST_GET_PER_PIECE_TAG_HISTORY = {
  subjectKey: string;
  displayTagId: string;
};
export type TRESPONSE_GET_PER_PIECE_TAG_HISTORY = {
  historyInfo: TTaghistoryInfo | null;
  pieceTagInfo: TTagInfo[];
};

export type TREQUEST_GET_BUNDLE_TAG_HISTORY = {
  subjectKey: string;
  subject: string;
  bundleDisplayTagId: string;
  domrole: string;
};

export type TTaghistoryInfo = {
  datetime: string;
  department: string;
  domRoleDn: string;
  eventName: string;
  subjectDn: string;
  hsk?: string;
};

export type TperPieceTagHistoryInfoWithMetadata = {
  historyInfo: TTaghistoryInfo | null;
  pieceTagInfo: {
    display_piece_tag: string;
    search_id: string;
  };
};

export type TRESPONSE_GET_BUNDLE_TAG_HISTORY = {
  bundleTagMetaData: TTagInfo[];
  perPieceTagHistoryInfoWithMetadata: TperPieceTagHistoryInfoWithMetadata[];
};

export type TTAG_TYPE = 'PER_PIECE_TAG' | 'MASTER_BUNDLE_TAG';

export type TScanLockSourceType = 'SEARCH_TAG_HISTORY' | 'SEARCH_AND_SCAN_COMPONENT'; // more types can be added
export type TScanLockDetails = {
  source: TScanLockSourceType | '';
  isLocked: boolean;
};

export type TScannedInfoWithScanLockDetails = {
  byteString: string;
  lockDetails: TScanLockDetails;
};

export type THeaderInput = {
  label: string;
  value: string | number;
};
export type TREQUEST_BctxGroupedDetails = {
  bctxItemList: TBctxItemWithoutSize[];
  subjectKey: string;
};

export type TKeyDisplayMap = {
  key: string;
  displayName: string;
};

export type TRESPONSE_GroupPOCommon = {
  error: string | null;
  responseStatus: 'SUCCESS' | 'FAILURE';
};

export type TRESPONSE_TREQUEST_BctxGroupedDetails = TRESPONSE_GroupPOCommon & {
  response: {
    groupedHeaderInfo: TKeyDisplayMap[];
    commonHeaderInfo: TKeyDisplayMap[];
    bctxGroupInfoWithCommonInfo: {
      bctxGroupInfo: {
        bctxGroupItemList: { bctxItemList: TBctxItemWithoutSize[] }[];
        versionedId: string;
      };
      bctxGroupCommonInfo: {
        [K in TBCTXKeys]: string;
      };
    };
  };
};

export type TWipTransferDetails = {
  wipFrom: { [key: string]: string };
  wipTo: { [key: string]: string };
  groupedHeaderInfo: TKeyDisplayMap[];
};

export type TPackingWipTransferDetails = TWipTransferDetails & {
  missingBctxItems: { [key: string]: string };
};

export type TBctxItemWithWipTransferDetails = {
  event: TBctxItemWithoutSizeAndBctxKey;
  wipTransferDetails: TWipTransferDetails;
};

export type TNewBctxItemInPOSplit = {
  bctx: TBctxItemWithoutSizeAndBctxKey;
  groupedHeaderInfo: TKeyDisplayMap[];
};

export type TRESPONSE_NewBctxSizeList = TRESPONSE_GroupPOCommon & {
  response: {
    sizes: string[];
  };
};

// Request DTOs
export type TComponentTagProcessHistoryRequestDTO = {
  subjectKey: string;
  componentTagId: string;
  componentType: string;
  bctxItemList: TBctxItemExt[];
  tagQuantity: number;
};

export type TBctxItemExt = {
  key: string;
  value: string;
};

// Response DTOs
export type TComponentTagProcessHistoryResponseDTO = {
  status: 'SUCCESS' | 'FAILURE';
  error?: string;
  history?: TComponentTagProcessInfo[];
};

export type TComponentTagProcessInfo = {
  processDetail: TProcessDetail;
  wipInfo: TWipInfoExt;
};

type TProcessDetail = {
  process_info: {
    dpt_id: string;
    dom_role: string;
  };
};

export type TWipInfoExt = {
  wipIn: number;
  wipOut: number;
  wipClear: number;
  wipOutPending: number;
  wipRejected: number;
};

export enum TTagType {
  MASTER_BUNDLE_TAG = 'MASTER_BUNDLE_TAG',
  COMPONENT_BUNDLE_TAG = 'COMPONENT_BUNDLE_TAG',
  PER_PIECE_TAG = 'PER_PIECE_TAG',
}

export type TTagScannedFromDevice = 'BLE_SCANNER' | 'RFID_VENDOR';
export type TREQUEST_GET_COMPONENT_TAG_BY_RFID = {
  subjectKey: string;
  rfidTag: string;
};

export type TRESPONSE_GET_COMPONENT_TAG_BY_RFID = {
  status: 'SUCCESS' | 'FAILURE';
  response: TTagInfo[];
  error?: string;
};

export type TREQUEST_TagInfoByRfidTag = {
  subjectKey: string;
  rfidTag: string;
};

export enum ETagTypeFromRfidTag {
  BUNDLE_TAG = 'BUNDLE_TAG',
  PIECE_TAG = 'PIECE_TAG',
  COMPONENT_TAG = 'COMPONENT_TAG',
}

export type TRESPONSE_TagInfoByRfidTag = {
  status: 'SUCCESS' | 'FAILURE';
  tagType: ETagTypeFromRfidTag;
  tagId: string;
  tagDisplayId: string;
  error?: string;
};
export type TWorkingHourToReasonsMap = {
  startTime: number;
  displayName: string;
  reasons: TProductionReasonDTO[];
  lastUpdatedAt: number;
  versioned_id?: string | null;
  session_block?: number;
};

export type TREQUEST_GET_SESSION_BLOCKS_WITH_REASONS = {
  subject: string;
  subject_key: string;
  session_date: string;
  bctx: Array<{ k: string; v: string }>;
  shift_id: string;
};

export type TSessionBlockWithReasons = {
  src_type: string;
  subject_key: string;
  start_time: string;
  end_time: string;
  session_block: string;
  reasons: string[];
  updatedAt?: number;
  versioned_id: string | null;
  sub_type: string;
};

export type TRESPONSE_GET_SESSION_BLOCKS_WITH_REASONS = {
  status: 'SUCCESS' | 'ERROR';
  data: {
    subject: string;
    session_plan_list: TSessionBlockWithReasons[];
  };
  errorCode?: string;
  message?: string;
};

export type TREQUEST_SAVE_SESSION_BLOCK_REASONS = {
  subject_key: string;
  versioned_id?: string;
  subject: string;
  date: string;
  bctx: Array<{ k: string; v: string }>;
  session_block: string;
  shift_id: string;
  reasons: string[];
  username: string;
};

export type TRESPONSE_SAVE_SESSION_BLOCK_REASONS = {
  status: 'SUCCESS' | 'ERROR';
  message?: string;
  errorCode?: string;
  data?: {
    versioned_id: string;
  };
  currentVersion?: number;
  providedVersion?: number;
};

export type TWorkingHourToReasonLineMap = {
  [line: string]: {
    [bctxKey: string]: {
      [shift: string]: {
        [startTime: number]: TWorkingHourToReasonsMap[];
      };
    };
  };
};
